export const LOCALE_COOKIE: string = 'LocaleStr'
export const USERNAME_MEMORY: string = 'usernameMemory'

export enum LoginState {
    VIEW_USERNAME = 0,
    VIEW_SERVER_CME = 1,
    VIEW_PASSWORD = 2
}
